import { CloudStreamContainer, ZLBoltStreamContainer } from "@zerolight-core/libzl-react"
import { useAppSelector } from "../store/hooks";
import { VisualizerStyle } from "./Visualizer.styles";

export function VisualizerView(props: {height?: string, hidden?: boolean})
{
    const isCloudStream = useAppSelector(s => "cloudStreamOptions" in s.configuration.currentVisualizerConfig);
    return <VisualizerStyle hidden={props.hidden}>
        {!isCloudStream
            ? <ZLBoltStreamContainer style={{ height: props.height ?? "100%" }} />
            : <CloudStreamContainer style={{ height: props.height ?? "100%" }} />
        }
    </VisualizerStyle>
}